const partnersSlider = new Swiper('.partners-slider', {
  slidesPerView: 1.6,
  loop: false,
  allowTouchMove: true,
  watchOverflow: true,
  spaceBetween: 20,
  pagination: {
    el: '.founders .swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.founders .swiper-button-next',
    prevEl: '.founders .swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 3,
      allowTouchMove: false,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 3,
      allowTouchMove: false,
      spaceBetween: 40,
    }
  }
});